<template>
  <div class="mt-2 mb-1">
    <span>{{label || $t('bill.text_119')}}</span>
    <span style="font-weight: 600; color: #4FA1F8; font-size: 18px;">{{ currencySign }} {{ amount }}</span>
    <template v-if="isSecondaryAmountShow">
      <span>, </span>
      <span>{{secondaryLabel || $t('bill.secondary_total')}}</span>
      <span style="font-weight: 600; color: #4FA1F8; font-size: 18px;">{{ currencySign }} {{ secondaryAmount }}</span>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { numerify } from '@/filters'

export default {
  props: {
    label: String,
    secondaryLabel: String,
    currencySign: {
      required: true,
      type: String,
    },
    total: Number,
    secondary_total: Number,
    secondaryTotalHidden: {
      type: Boolean,
      default: false,
    },
    secondaryTotalShown: {
      type: Boolean,
      default: false,
    },
    // 是否需要 在非系统视图时,开启二次定价且未展示原账单,允许总计展示未二次定价后的总计
    setSecondaryToAmount: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['isAdminMode', 'isDomainMode']),
    ...mapState('common', {
      costConversionAvaliable: state => state.bill.globalConfig.cost_conversion_available,
      costConversionOrigin: state => state.bill.costConversionOrigin,
    }),
    amount () {
      if (this.setSecondaryToAmount && !this.isAdminMode && this.costConversionAvaliable && !this.costConversionOrigin) {
        return numerify(this.secondary_total, '0,0.00')
      }
      return numerify(this.total, '0,0.00')
    },
    secondaryAmount () {
      return numerify(this.secondary_total, '0,0.00')
    },
    isSecondaryAmountShow () {
      if (this.secondaryTotalHidden) {
        return false
      }
      if (this.secondaryTotalShown) {
        return true
      }
      return (this.isAdminMode && this.costConversionAvaliable) || (!this.isAdminMode && this.costConversionAvaliable && this.costConversionOrigin)
    },
  },
}
</script>
